export enum TypeOfEquipment {
  New = 'new',
  Used = 'used',
  Special = 'special',
}
